import {useEffect, useState} from 'react';

/**
 * useDelayedState
 * ===============
 * @description triggers callback after delay from most recent setState triggered
 * @param initialState
 * @param callBack function to trigger with new value as parameter
 * @param timeoutDelay replace default delay of 1 second
 * @returns state and setState
 */
export const useDelayedState = <T>(
    initialState: T,
    callBack: (state: T) => void,
    timeoutDelay = 300,
) => {
    const [state, setState] = useState(initialState);

    useEffect(() => {
        const debounce = setTimeout(() => {
            callBack(state);
        }, timeoutDelay);
        return () => clearTimeout(debounce);
    }, [state]);

    return {state, setState};
};
